module.exports = __webpack_public_path__ + "static/media/intro.a8ed7593.mp3";